import { z } from 'zod';

/**
 * Wire contract for GET /api/flow/search — the global omnibox.
 *
 * Result schemas are field subsets of the fuller AccountRowSchema /
 * ContactRowSchema wire rows (pinned by flow-search-contract.test.ts).
 */

export const AccountSearchResultSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email_domain_link: z.string().nullable(),
  propensity_score: z.number().nullable(),
  industry: z.string().nullable(),
});
export type AccountSearchResult = z.infer<typeof AccountSearchResultSchema>;

export const ContactSearchResultSchema = z.object({
  id: z.string(),
  account_id: z.string().nullable(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  title: z.string().nullable(),
  account_name: z.string().nullable(),
});
export type ContactSearchResult = z.infer<typeof ContactSearchResultSchema>;

export const FlowSearchScopeSchema = z.enum(['my', 'all']);
export type FlowSearchScope = z.infer<typeof FlowSearchScopeSchema>;

export const FlowSearchResponseSchema = z.object({
  accounts: z.array(AccountSearchResultSchema),
  contacts: z.array(ContactSearchResultSchema),
  scope: FlowSearchScopeSchema,
});
export type FlowSearchResponse = z.infer<typeof FlowSearchResponseSchema>;
